import { createSelector } from 'reselect'
import { toSafeObject, toSafeArray } from '../../store/helpers/StateHelper'
import { sortBy } from '../../store/helpers/SortingHelper'

/**
 * Create a selector for internal sort criteria
 */
export const queryParametersSelector = createSelector(
	(state) => state.users.get('internalQueryParameters'),
	(internalQueryParameters) => toSafeObject(internalQueryParameters)
)

/**
 * Create a selector for the filtered and sorted internal users
 */
export const internalUsersSelector = createSelector(
	(state) => state.users.get('internalUsers'),
	(state) => state.users.get('internalQueryParameters'),
	(internalUsers, queryParameters) => {

		let queryObject = toSafeObject(queryParameters)

		const getFilteredUsers = (users) => {
			if (queryObject && queryObject.query) { 
				let fixedQuery = queryObject.query.trim().toLowerCase()
				return users.filter((x) => {
					return x.UserName.trim().toLowerCase().startsWith(fixedQuery) ||
					x.Name.trim().toLowerCase().includes(fixedQuery)
				})	
			} else 
				return users
		}

		const getSortedUsers = (users) => {
			if (queryObject && queryObject.sortBy) {
				return sortBy(users, queryObject.sortBy, queryObject.sortDirection)
			} else return users
		}

		let result = toSafeArray(internalUsers)
		result = getFilteredUsers(result)
		result = getSortedUsers(result)		
		return result
	}
)
